import { Injectable } from '@angular/core';
import { TmWindow } from '../window/tm-window.interface';
import { WindowRef } from '@trademe/tangram';
import { INewRelicService } from './new-relic-service.interface';
import { getErrorMessage } from '@classifieds-sell/shared';
import { REQUIRED_FIELD_ERROR_MESSAGE, SAME_PHOTO_ATTACHED_ERROR_MESSAGE } from '@classifieds-sell/trademe-core-ui';

export const SLO_NOTICEABLE_ERRORS: string[] = [
    REQUIRED_FIELD_ERROR_MESSAGE,
    SAME_PHOTO_ATTACHED_ERROR_MESSAGE
];

@Injectable({
    providedIn: 'root'
})

export class NewRelicClientService implements INewRelicService {
    constructor(private _windowRef: WindowRef<TmWindow>) {}

    public noticeError(error: string | Error, expected = false) {
        this._windowRef.useWindow((window: TmWindow) => {
            if (window.newrelic && window.newrelic.noticeError) {
                // this will allow the SLO's to filter expected user errors from the error rate as we don't care about these
                window.newrelic.noticeError(error, {
                    'error.expected': expected
                });
            }
        });
    }

    public isExpected(error: string | Error) {
        const errorMessage =
            typeof error === 'string' ? error : getErrorMessage(error);
        return !!SLO_NOTICEABLE_ERRORS.find(noticeableError => noticeableError.toLowerCase() === errorMessage.toLowerCase());
    }
}
